import {
  GET_PRODUCT_PENDING,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_ERROR,
  POST_PRODUCT_PENDING,
  POST_PRODUCT_SUCCESS,
  POST_PRODUCT_ERROR,
  PUT_PRODUCT_PENDING,
  PUT_PRODUCT_SUCCESS,
  PUT_PRODUCT_ERROR,
  DELETE_PRODUCT_PENDING,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_ERROR,
  PRODUCT_DATA,
  SET_PRODUCT_MODAL,
} from "../../../actions/master-data/product";

const initialState = {
  pending: false,
  error: null,
  data: null,
  detailData: null,
  isOpenModal: false,
  modalType: "",
};

const product = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case GET_PRODUCT_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case PUT_PRODUCT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case PUT_PRODUCT_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case PUT_PRODUCT_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case DELETE_PRODUCT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case DELETE_PRODUCT_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case POST_PRODUCT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case POST_PRODUCT_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case POST_PRODUCT_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case PRODUCT_DATA:
      return {
        ...state,
        detailData: action.data,
      };
    case SET_PRODUCT_MODAL:
      return {
        ...state,
        isOpenModal: action.data.isOpen,
        modalType: action.data.modalType,
      };
    default:
      return state;
  }
};

export default product;
